/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PhysioOrder from './physio-order';
import PhysioOrderDetail from './physio-order-detail';
import PhysioOrderUpdate from './physio-order-update';
import PhysioOrderDeleteDialog from './physio-order-delete-dialog';

const PhysioOrderRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PhysioOrder />} />
    <Route path="new" element={<PhysioOrderUpdate />} />
    <Route path=":id">
      <Route index element={<PhysioOrderDetail />} />
      <Route path="edit" element={<PhysioOrderUpdate />} />
      <Route path="delete" element={<PhysioOrderDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PhysioOrderRoutes;
